module.exports = __webpack_public_path__ + "img/2024080214455414YFj.1df72a38.png";